//@flow
import * as React from 'react'
import { Field } from 'redux-form';
import renderTextField from '../MaterialUi/renderTextField';
import RFCheckboxField from '../ReduxFormComps/RFCheckboxField'
import type { ContainerRowReduxTextField$Props } from './flowTypes'

const styles = {
    textFieldStyle: {
        width: '310px',
        paddingBottom: '10px'
    }
}

const ContainerRowReduxTextField=(props:ContainerRowReduxTextField$Props)=>{
    let canRenderTextField = true
    if (props.checkboxField && props.checkboxBool){
        canRenderTextField = false
    }
    return (
        <div className="row">
            <div className='col-sm'>
                {canRenderTextField?(
                <Field
                    name={props.field}
                    component={renderTextField}
                    label={props.label}
                    style={styles.textFieldStyle}
                    type={props.textType?props.textType:'string'}
                    onChange={(e)=> textOnChange(e,props)}
                />
                ):null}
                {props.checkboxField?(
                <Field name={props.checkboxField} 
                    component={RFCheckboxField} 
                    label={props.checkboxLabel?props.checkboxLabel:'This field not found in Document'}
                />
                ):null}
            </div>
        </div> 
    )
}

const textOnChange=(e,props:ContainerRowReduxTextField$Props)=>{
    if (props.textOnChangeFunc){
        const textOnChangeFunc = props.textOnChangeFunc
        const parentProps = (props.parentProps:any)
        textOnChangeFunc(e,parentProps)
    }
}

export default ContainerRowReduxTextField


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowReduxTextField.js